import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Navbar, Input, ListGroup, ListGroupItem, Button, Collapse } from 'reactstrap';
import Swipeable from 'react-swipeable';
import ReactGA from 'react-ga';
import Img from 'react-image';
import { FadeLoader } from 'react-spinners';

import { getPlaces, setPackage, getPackage, savePackage } from '../actions/PackageActions';
import noimage from '../assets/images/noimage.jpg';
import degrad from '../assets/images/de-grad.png';

class Package extends React.Component {
	constructor(props) {
		super(props);
		this.state = { text: '', arrCollapse: [], toggle: false };
		this.onChange = this.onChange.bind(this);
	}
	
	componentWillMount() {
		ReactGA.pageview('/CreaPackage/DondeQuieren');
		this.props.getPackage();
		this.props.getPlaces();
	}

	onChange(e) {
		this.setState({ text: e.target.value });
	}

	onKeyPress(e) {
		if (e.key === "Enter") {
			localStorage.setItem('otherPlace', this.state.text);
		}
	}

	_toggle() {
		this.setState({ toggle: !this.state.toggle });
	}

	_swipingLeft() {
		localStorage.setItem('otherPlace', this.state.text);
		this.props.history.push('package_artistas');
	}

	_toggleCollapse(i) {
		let arrCollapse = this.state.arrCollapse;
		arrCollapse[i] = !arrCollapse[i];
		this.setState({ arrCollapse });
	}

	_select(place, spot) {
		let params = { name: place, spot }
		ReactGA.pageview('/CreaPackage/DondeQuieren/' + spot.name);
		this.props.setPackage({ ...this.props.package, place: params });
		this.props.savePackage();
	}

	_selected(name) {
		let place = this.props.package.place || {};
		let spot = place.spot || {};
		return spot.name === name ? 'selected' : '';
	}

	_goBack() {
		this.props.history.goBack();
	}

	_renderCount(category) {
		let place = this.props.package.place || {};
		if (place.name === category) {
			return <span>{' '} ({1})</span>
		}

		return <div></div>;
	}

	_renderSubItems(item) {
		if (item.list && item.list.length > 0) {
			return item.list.map((obj, i) => (
				<div className={"sp-mark " + this._selected(obj.name)} key={i} onClick={() => this._select(item.name, obj)}>
					<div className="photoContainer">
						<span className="sp-mark-ckeck">
							<i className="ico-check">&nbsp;</i>
						</span>
						<Img
							src={[obj.img, noimage]}
							loader={<FadeLoader color={'#ccc'} loading={true} />}
						/>
					</div>
					<span className="sp-mark-label">
						<span>{obj.name}</span>
						<img alt="" src={degrad} />
					</span>
				</div>
			));
		}
		else return [];
	}

	_renderItems(items) {
		if (items.length > 0) {
			return items.map((obj, i) => (
				<div className="videoContainer" key={i}>
					<ListGroupItem onClick={() => this._toggleCollapse(i)}>
						<i className={"sp-ff ico-sp-cvright sp-orange " + (this.state.arrCollapse[i] ? 'open' : '')}></i>
						{obj.name}
						{this._renderCount(obj.name)}
					</ListGroupItem>
					<Collapse isOpen={this.state.arrCollapse[i]}>
						<div className="fred">
							{this._renderSubItems(obj)}
						</div>
					</Collapse>
				</div>
			));
		}
		else return [];
	}

	render() {
		const places = this._renderItems(this.props.places);
		return (
			<Swipeable onSwipedLeft={() => this._swipingLeft()} >
				<div className="sp-page">
					<Navbar className="sp-nav">
						<div className="sp-label">¿Dónde quieren celebrarlo?</div>
						<div>&nbsp;</div>
					</Navbar>
					<div className="sp-other-field">
						<Input
							placeholder="¿Qué otro lugar desea celebrar?"
							type="text"
							value={this.state.text}
							onChange={this.onChange}
							onKeyPress={e => this.onKeyPress(e)}
						/>
					</div>

					<div className="sp-content pckg">
						<ListGroup className="sp-list ico">
							{places}
						</ListGroup>
					</div>

					<div className="sp-navigator">
						<Button className="nonbt">VOLVER</Button>
						<div className="steps">
							<span className="active">&nbsp;</span>
							<span>&nbsp;</span>
							<span>&nbsp;</span>
						</div>
						<Button onClick={() => this._swipingLeft()}>AVANZAR</Button>
					</div>
				</div>
			</Swipeable>
		);
	}
}

const mapStateToProps = state => ({ places: state.PackageReducer.places, package: state.PackageReducer.package });

export default withRouter(connect(mapStateToProps, { getPlaces, setPackage, getPackage, savePackage })(Package));


// WEBPACK FOOTER //
// ./src/screens/Package.js